import { z } from 'zod';

/** A treasury transfer in the list, with both account names + the JE number. */
export interface TreasuryTransfer {
  id: string;
  docNumber: string;
  fromAccountId: string;
  fromAccountCode: string;
  fromAccountName: string;
  toAccountId: string;
  toAccountCode: string;
  toAccountName: string;
  amount: string;
  currencyCode: string;
  /** What the destination account received — set on cross-currency transfers, null otherwise. */
  toAmount: string | null;
  toCurrencyCode: string | null;
  transferDate: string;
  note: string | null;
  journalEntryNumber: string | null;
  createdAt: string;
}

/**
 * Create a transfer — the amount is in the SOURCE account's currency. When the
 * destination account uses a different currency, the server converts at the
 * exchange rate effective on the transfer date (rejecting when no rate is set).
 */
export const TreasuryTransferCreateSchema = z.object({
  fromAccountId: z.string().uuid(),
  toAccountId: z.string().uuid(),
  amount: z.string().regex(/^\d+(\.\d{1,4})?$/, 'must be a positive amount'),
  transferDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'must be YYYY-MM-DD'),
  note: z.string().max(500).optional(),
}).refine((v) => v.fromAccountId !== v.toAccountId, { message: 'from and to must differ', path: ['toAccountId'] })
  .refine((v) => Number(v.amount) > 0, { message: 'amount must be greater than zero', path: ['amount'] });
export type TreasuryTransferCreate = z.infer<typeof TreasuryTransferCreateSchema>;
